import api from "../api/api";

export const empresaService = {
    getFormasPgtoPublico: async (idEmpresa: number) => {
        const response = await api.get(`/empresa/${idEmpresa}/public/forma_pgto`);
        return response.data;
    }
};